import type { FC } from 'react';
import React from 'react';
import { styled } from '@compiled/react';

import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { N400, N900 } from '@atlaskit/theme/colors';

import { ProfileAvatar } from '@confluence/profile';

import { ActionTime } from '../ActionTime';

import { ActivityLineUpdateLink } from './ActivityLineUpdateLink';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ActionWrapper = styled.div({
	display: 'flex',
	minHeight: '34px',
	marginBottom: token('space.150', '12px'),
});

const profileWrapperStyles = xcss({
	marginRight: 'space.100',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ActionMessage = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'> a': {
		'&:hover': {
			color: token('color.text', N900),
		},
		color: token('color.text', N900),
		fontSize: '14px',
		lineHeight: '20px',
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ActionTimeWrapper = styled.div({
	lineHeight: '14px',
	fontSize: '11px',
	color: token('color.text', N400),
});

type Props = {
	type: 'COMMENT' | 'CREATE' | 'EDIT';

	actionTime: string;
	userId: string | null;
	avatarUrl: string;
	userDisplayName: string | null;

	link: string;
	groupSize: number;
};

export const ActivityLineUpdateDetail: FC<Props> = ({
	type,
	actionTime,
	userId,
	avatarUrl,
	userDisplayName,
	link,
	groupSize,
}) => {
	const name = userDisplayName ?? '';
	return (
		<ActionWrapper data-testid="activity-update-detail">
			<Box xcss={profileWrapperStyles}>
				<ProfileAvatar userId={userId} src={avatarUrl} canViewProfile size="medium" name={name} />
			</Box>
			<ActionMessage>
				<ActivityLineUpdateLink
					type={type}
					userDisplayName={userDisplayName}
					link={link}
					groupSize={groupSize}
					activityDropdownLineItem
				/>
				<ActionTimeWrapper>
					<ActionTime actionTime={actionTime} />
				</ActionTimeWrapper>
			</ActionMessage>
		</ActionWrapper>
	);
};
